<template>
    <div class="view-all-my-favorites-container">
        <div class="return">
            <button-back
                :route-exception="'dashboard'"
                class="return__button-return"
            ></button-back>
        </div>
        <div class="view-all-my-favorites-section">
            <div
                v-for="asset in assets"
                :key="asset.id"
                class="view-all-my-favorites-section__asset"
            >
                <transition name="fade">
                    <assets-card
                        :key="asset.id"
                        :asset="asset"
                        class="view-all-my-favorites-section__asset-style"
                    ></assets-card>
                </transition>
            </div>
        </div>

        <template v-if="assets.length < totalAssetsCount">
            <LoadMore
                class="view-all-my-creations__load-more"
                :total-assets-count="totalAssetsCount"
                :assets-shown="assets.length"
                @click.native="moreBlueprints"
            />
        </template>
    </div>
</template>

<script>
import AssetsCard from '@/components/common/asset/AssetCard.vue';
import ButtonBack from '@/components/common/ButtonBack.vue';
import LoadMore from '@/components/common/LoadMoreBlueprints';

export default {
    name: 'ViewOwnedBlueprints',
    components: { AssetsCard, ButtonBack, LoadMore },
    props: {
        assets: { type: [Array, Object], default: () => {} },
        totalAssetsCount: {
            type: Number,
            default: 0,
        },
        pagination: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
        moreBlueprints() {
            this.$emit('update:number');
        },
    },
};
</script>

<style scoped lang="scss">
.return {
    padding-top: 20px;
    padding-left: 55px;

    @media (max-width: $sm-up) {
        padding-top: 70px;
        padding-left: 55px;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        padding-left: 35px;
    }
}

.view-all-my-favorites-section {
    margin: 0 5% 0 5%;
    height: auto;
    width: 80%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    grid-gap: 1rem;
    margin-bottom: 10rem;
    @media (max-width: $xl-up) {
        grid-template-columns: repeat(2, 1fr);
        width: 90%;
    }
    @media (max-width: $sm-up) {
        grid-template-columns: 1fr;
        width: auto;
        grid-gap: 0;
        height: 100%;
        margin: 10% auto 30% auto;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        margin: 15% auto auto auto;
        padding-bottom: 12rem;
        grid-gap: 1rem;
    }
    &__asset {
        grid-column: auto;
        margin: 3rem auto 3rem auto;
        @media (max-width: $sm-up) {
            margin: 0;
            justify-self: center;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            justify-self: center;
        }
    }
    &__asset-style {
        height: 229px;
        width: 415px;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 290px;
        }
    }
}
.view-all-my-creations__load-more {
    margin-bottom: 10rem;
}
</style>
